import React, { FC } from 'react';
import { Input, Typography } from 'antd';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

import { useGetApplication } from '~/controllers/wizard';

import { DocumentInput, Form } from '~/components';
import buildNamePath from '~/utils/buildNamePath';
import { Person } from '~/types/Person';

const BeneficialOwnerAdditionalInformation: FC = () => {
  const { t } = useTranslation('fillApplication');
  const applicationQuery = useGetApplication();

  if (!applicationQuery.data) {
    return null;
  }

  return (
    <Form.Visible<Person[] | undefined>
      name={['shareholders', 'beneficialOwners']}
      visibleIf={(beneficialOwners) => !isEmpty(beneficialOwners || [])}
    >
      <Typography.Title level={4}>{t('Additional information').toUpperCase()}</Typography.Title>
      <Typography.Paragraph>
        {t(
          'In case of complex ownership structure please provide comments and/or schemas that might be relevant.'
        )}
      </Typography.Paragraph>
      <Form.Item name={additionalInfoFiles}>
        <DocumentInput name="photos" variant="default" />
      </Form.Item>
      <Form.Item name={additionalInfoComment} textarea>
        <Input.TextArea autoSize={{ minRows: 4 }} placeholder={t('Enter your comment')} />
      </Form.Item>
    </Form.Visible>
  );
};

export const additionalInfo = 'additionalInfo';
const n = buildNamePath(['shareholders', additionalInfo]);
export const additionalInfoFiles = n('files');
export const additionalInfoComment = n('comment');

export default BeneficialOwnerAdditionalInformation;
